import { getConstantsFor } from "../asyncAction";

const PREFIX = "GROUP_ORDER";

export const CREATE_GROUP_ORDER = getConstantsFor(`${PREFIX}/CREATE`);
export const JOIN_GROUP_ORDER = getConstantsFor(`${PREFIX}/JOIN`);
export const POLL_GROUP_ORDER = getConstantsFor(`${PREFIX}/POLL`);
export const SYNC_PARTICIPANT_ITEMS = getConstantsFor(`${PREFIX}/SYNC_ITEMS`);
export const CLOSE_GROUP_ORDER = getConstantsFor(`${PREFIX}/CLOSE`);
export const CANCEL_GROUP_ORDER = getConstantsFor(`${PREFIX}/CANCEL`);
export const BEGIN_PARTICIPANT_PAYMENT = getConstantsFor(`${PREFIX}/BEGIN_PAYMENT`);
export const APPROVE_PARTICIPANT_PAYMENT = getConstantsFor(`${PREFIX}/APPROVE_PAYMENT`);

export const SET_ACTIVE = `${PREFIX}/SET_ACTIVE`;
export const LEAVE_GROUP_ORDER = `${PREFIX}/LEAVE`;
export const ADD_LOCAL_ITEM = `${PREFIX}/ADD_LOCAL_ITEM`;
export const REMOVE_LOCAL_ITEM = `${PREFIX}/REMOVE_LOCAL_ITEM`;
export const CLEAR_LOCAL_ITEMS = `${PREFIX}/CLEAR_LOCAL_ITEMS`;
export const UPDATE_LOCAL_ITEM_QUANTITY = `${PREFIX}/UPDATE_LOCAL_ITEM_QUANTITY`;
export const ACTIVITY_EVENT = `${PREFIX}/ACTIVITY_EVENT`;
export const SET_PARTICIPANT_IDENTITY = `${PREFIX}/SET_PARTICIPANT_IDENTITY`;
export const CLEAR_ACTIVITY_EVENTS = `${PREFIX}/CLEAR_ACTIVITY_EVENTS`;
